<template>
    <div class="fa-attr">
        <span class="fa-label">{{ value.label }}</span>
        <div class="fa-grid">
            <template v-for="(file, index) in value.value">
            <div
                :key="index"
                class="fa-card"
                v-if="getMedia(file)"
            >
                <!-- Image preview on top -->
                <div
                    v-if="isImage(getMedia(file).name)"
                    class="fa-card-preview"
                >
                    <img
                        :src="`${baseUrl}/storage/${getMedia(file).id}?token=${token}`"
                        :alt="getMedia(file).name"
                    />
                </div>
                <!-- File icon for non-images -->
                <div v-else class="fa-card-icon-block">
                    <i :class="fileIcon(getMedia(file).name)"></i>
                </div>
                <!-- Footer -->
                <div class="fa-card-footer">
                    <span class="fa-card-name">{{ getMedia(file).name }}</span>
                    <a
                        :href="`${baseUrl}/storage/download/${getMedia(file).id}?token=${token}`"
                        :download="getMedia(file).name"
                        class="fa-card-dl"
                    >
                        <i class="fal fa-download text-white"></i>
                    </a>
                </div>
            </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'FileUploadAttribute',
    props: ['value', 'medias'],
    data() {
        return {
            baseUrl: this.$store.state.baseURL,
            token: this.$store.state.auth.token
        }
    },
    methods: {
        getMedia(id) {
            return this.medias.filter((media) => media.id == id)[0]
        },
        isImage(name) {
            if (!name) return false
            const ext = name.split('.').pop().toLowerCase()
            return ['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)
        },
        fileIcon(name) {
            if (!name) return 'fal fa-file'
            const ext = name.split('.').pop().toLowerCase()
            if (['jpg', 'jpeg', 'png', 'gif', 'webp'].includes(ext)) return 'fal fa-file-image'
            if (['pdf'].includes(ext)) return 'fal fa-file-pdf'
            if (['doc', 'docx'].includes(ext)) return 'fal fa-file-word'
            if (['xls', 'xlsx'].includes(ext)) return 'fal fa-file-excel'
            if (['mp4', 'avi', 'mov'].includes(ext)) return 'fal fa-file-video'
            if (['mp3', 'wav', 'ogg'].includes(ext)) return 'fal fa-file-audio'
            return 'fal fa-file'
        }
    }
}
</script>

<style scoped>
.fa-label {
    display: block;
    font-size: 0.72rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.06em;
    color: #94a3b8;
    margin-bottom: 10px;
}

.fa-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
    gap: 12px;
}

.fa-card {
    border: 1px solid #e5e7eb;
    border-radius: 12px;
    overflow: hidden;
    transition: border-color 0.2s, box-shadow 0.2s;
}

.fa-card:hover {
    border-color: #bfdbfe;
    box-shadow: 0 2px 10px rgba(59, 130, 246, 0.08);
}

.fa-card-preview {
    height: 140px;
    overflow: hidden;
    background: #f8fafc;
}

.fa-card-preview img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
}

.fa-card-icon-block {
    height: 100px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f8fafc;
    font-size: 2rem;
    color: #94a3b8;
}

.fa-card-footer {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    border-top: 1px solid #f1f5f9;
}

.fa-card-name {
    flex: 1;
    font-size: 0.78rem;
    font-weight: 600;
    color: #1e293b;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    min-width: 0;
}

.fa-card-dl {
    width: 30px;
    height: 30px;
    border-radius: 8px;
    background: #3b82f6;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    transition: background 0.2s;
}

.fa-card-dl:hover {
    background: #2563eb;
}

.fa-card-dl i {
    color: #fff !important;
    font-size: 0.78rem;
}
</style>
